module.exports = __webpack_public_path__ + "img/项目申请.80cf4e01.png";